module.exports = __webpack_public_path__ + "statics/img/1736125140526.png";